const blogPosts = [
  {
    slug: "how-to-install-apk-files-android-2026",
    title: "How to Install APK Files on Android Safely in 2026 — Complete Step-by-Step Guide",
    category: "Android Guides",
    author: "Alpha APK Team",
    updated: "June 2026",
    content: `Your blog content here`
  }
];

export default blogPosts;